webpackJsonp([263791100135453],{

/***/ 401:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cert.97e9c475.jpg";

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _toggleOpen = __webpack_require__(79);
	
	var _toggleOpen2 = _interopRequireDefault(_toggleOpen);
	
	var _cert = __webpack_require__(514);
	
	var _cert2 = _interopRequireDefault(_cert);
	
	__webpack_require__(401);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cert = function Cert(_ref) {
	  var isOpen = _ref.isOpen,
	      toggleOpen = _ref.toggleOpen;
	
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'cert__wrapper' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns' },
	        _react2.default.createElement(
	          'div',
	          { className: 'cert' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'h1' },
	            '\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'card__list' },
	            _react2.default.createElement(
	              'li',
	              { className: 'card__item' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card__img' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'img__mini' },
	                  _react2.default.createElement('img', { onClick: toggleOpen, src: _cert2.default, alt: 'cert1' })
	                ),
	                isOpen && _react2.default.createElement(
	                  'div',
	                  { className: 'img__normal' },
	                  _react2.default.createElement('img', { onClick: toggleOpen, src: _cert2.default, alt: 'cert1' })
	                )
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'item__caption' },
	                '\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'item__text' },
	                '\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'card__item' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card__img' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'img__mini' },
	                  _react2.default.createElement('img', { onClick: toggleOpen, src: _cert2.default, alt: 'cert1' })
	                ),
	                isOpen && _react2.default.createElement(
	                  'div',
	                  { className: 'img__normal' },
	                  _react2.default.createElement('img', { onClick: toggleOpen, src: _cert2.default, alt: 'cert1' })
	                )
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'item__caption' },
	                '\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'item__text' },
	                '\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'card__item' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card__img' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'img__mini' },
	                  _react2.default.createElement('img', { onClick: toggleOpen, src: _cert2.default, alt: 'cert1' })
	                ),
	                isOpen && _react2.default.createElement(
	                  'div',
	                  { className: 'img__normal' },
	                  _react2.default.createElement('img', { onClick: toggleOpen, src: _cert2.default, alt: 'cert1' })
	                )
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'item__caption' },
	                '\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'item__text' },
	                '\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'card__item' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card__img' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'img__mini' },
	                  _react2.default.createElement('img', { onClick: toggleOpen, src: _cert2.default, alt: 'cert1' })
	                ),
	                isOpen && _react2.default.createElement(
	                  'div',
	                  { className: 'img__normal' },
	                  _react2.default.createElement('img', { onClick: toggleOpen, src: _cert2.default, alt: 'cert1' })
	                )
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'item__caption' },
	                '\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'item__text' },
	                '\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _toggleOpen2.default)(Cert);
	module.exports = exports['default'];

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHBhdGggZmlsbD0iIzFBMUEzRiIgZD0iTTY1LjIgMjMuM2MwIDEuNy0xLjQgMy0zIDMtMS43IDAtMy0xLjQtMy0zIDAtMS43IDEuNC0zIDMtM3MzIDEuMyAzIDNtOC45IDBjMCAxLjctMS40IDMtMyAzLTEuNyAwLTMtMS40LTMtMyAwLTEuNyAxLjQtMyAzLTNzMyAxLjMgMyAzbTExIDBjMCAxLjctMS40IDMtMyAzLTEuNyAwLTMtMS40LTMtMyAwLTEuNyAxLjQtMyAzLTNzMyAxLjMgMyAzIi8+PHBhdGggZmlsbD0iIzFBMUEzRiIgZD0iTTkyLjcgODguOEg3LjRjLTEuMyAwLTIuNC0xLjEtMi40LTIuNFYxMy4zYzAtMS4zIDEuMS0yLjQgMi40LTIuNGg4NS4zYzEuMyAwIDIuNCAxLjEgMi40IDIuNHY3My4yYzAgMS4zLTEuMSAyLjMtMi40IDIuM005LjggODQuMWg4MC41VjE1LjdIOS44djY4LjR6Ii8+PHBhdGggZmlsbD0iIzFBMUEzRiIgZD0iTTgyIDM1LjRINy44Yy0xLjMgMC0yLjQtMS4xLTIuNC0yLjQgMC0xLjMgMS4xLTIuNCAyLjQtMi40SDgyYzEuMyAwIDIuNCAxLjEgMi40IDIuNCAwIDEuNC0xLjEgMi40LTIuNCAyLjQiLz48cGF0aCBmaWxsPSIjMjhDMjNFIiBkPSJNNTcuNCA1MC4zYy42IDAgMS4yLjIgMS43LjcuOS45LjkgMi40IDAgMy40TDQ0LjQgNjkuMWMtLjkuOS0yLjQuOS0zLjQgMC0uOS0uOS0uOS0yLjQgMC0zLjRMNTUuNyA1MWMuNS0uNSAxLjEtLjcgMS43LS43Ii8+PHBhdGggZmlsbD0iIzI4QzIzRSIgZD0iTTQyLjcgNTMuMmMxLjMgMCAyLjQgMS4xIDIuNCAyLjRWNjVoOS40YzEuMyAwIDIuNCAxLjEgMi40IDIuNHMtMS4xIDIuNC0yLjQgMi40SDQyLjdjLTEuMyAwLTIuNC0xLjEtMi40LTIuNFY1NS42YzAtMS4zIDEuMS0yLjQgMi40LTIuNCIvPjwvc3ZnPg=="

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHBhdGggZmlsbD0iIzI4QzIzRSIgZD0iTTY3IDQxLjhjLTEuNCAwLTIuNi0xLjEtMi42LTIuNlYyOS4xSDU0LjNjLTEgMC0xLjktLjYtMi4zLTEuNS0uOC0xLjkuNi0zLjcgMi4zLTMuN2gxMi45YzEuMyAwIDIuNCAxLjEgMi40IDIuNHYxMi45YzAgMS41LTEuMiAyLjYtMi42IDIuNk0yNC4yIDYxLjJjMCAxLjctMS40IDMtMyAzLTEuNyAwLTMtMS40LTMtMyAwLTEuNyAxLjQtMyAzLTNzMyAxLjMgMyAzbTAgMTEuOGMwIDEuNy0xLjQgMy0zIDMtMS43IDAtMy0xLjQtMy0zIDAtMS43IDEuNC0zIDMtM3MzIDEuMyAzIDNNMzYgNzNjMCAxLjctMS40IDMtMyAzLTEuNyAwLTMtMS40LTMtMyAwLTEuNyAxLjQtMyAzLTMgMS43IDAgMyAxLjMgMyAzIi8+PHBhdGggZmlsbD0iIzFBMUEzRiIgZD0iTTkzLjIgODguNkg3LjNjLTEuMyAwLTIuNC0xLjEtMi40LTIuNFYxM2MwLTEuMyAxLjEtMi40IDIuNC0yLjRoODUuNWMxLjMgMCAyLjQgMS4xIDIuNCAyLjR2NzMuMmMwIDEuMy0xLjEgMi40LTIuNCAyLjRNOSA4NC41aDgxLjFWMTUuOEg5djY4Ljd6Ii8+PHBhdGggZmlsbD0iIzFBMUEzRiIgZD0iTTgxLjQgODguOGMtMS40IDAtMi42LTEuMS0yLjYtMi40VjEzLjJjMC0xIC42LTIgMS41LTIuMyAxLjgtLjcgMy42LjYgMy42IDIuMnY3My40YzAgMS4zLTEuMSAyLjMtMi41IDIuMyIvPjwvc3ZnPg=="

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHBhdGggZmlsbD0iIzFBMUEzRiIgZD0iTTY1LjIgMjMuM2MwIDEuNy0xLjQgMy0zIDMtMS43IDAtMy0xLjQtMy0zIDAtMS43IDEuNC0zIDMtM3MzIDEuMyAzIDNtOC45IDBjMCAxLjctMS40IDMtMyAzLTEuNyAwLTMtMS40LTMtMyAwLTEuNyAxLjQtMyAzLTNzMyAxLjMgMyAzbTExIDBjMCAxLjctMS40IDMtMyAzLTEuNyAwLTMtMS40LTMtMyAwLTEuNyAxLjQtMyAzLTNzMyAxLjMgMyAzIi8+PHBhdGggZmlsbD0iIzFBMUEzRiIgZD0iTTkyLjcgODguOEg3LjRjLTEuMyAwLTIuNC0xLjEtMi40LTIuNFYxMy4zYzAtMS4zIDEuMS0yLjQgMi40LTIuNGg4NS4zYzEuMyAwIDIuNCAxLjEgMi40IDIuNHY3My4yYzAgMS4zLTEuMSAyLjMtMi40IDIuM005LjggODQuMWg4MC41VjE1LjdIOS44djY4LjR6Ii8+PHBhdGggZmlsbD0iIzFBMUEzRiIgZD0iTTgyIDM1LjRINy44Yy0xLjMgMC0yLjQtMS4xLTIuNC0yLjQgMC0xLjMgMS4xLTIuNCAyLjQtMi40SDgyYzEuMyAwIDIuNCAxLjEgMi40IDIuNCAwIDEuNC0xLjEgMi40LTIuNCAyLjQiLz48cGF0aCBmaWxsPSIjMjhDMjNFIiBkPSJNNDIuNyA2OS44Yy0uNiAwLTEuMi0uMi0xLjctLjctLjktLjktLjktMi40IDAtMy40TDU1LjcgNTFjLjktLjkgMi40LS45IDMuNCAwIC45LjkuOSAyLjQgMCAzLjRMNDQuNCA2OS4xYy0uNS40LTEuMS43LTEuNy43Ii8+PHBhdGggZmlsbD0iIzI4QzIzRSIgZD0iTTU3LjQgNjYuOGMtMS4zIDAtMi40LTEuMS0yLjQtMi40VjU1aC05LjRjLTEuMyAwLTIuNC0xLjEtMi40LTIuNCAwLTEuMyAxLjEtMi40IDIuNC0yLjRoMTEuOGMxLjMgMCAyLjQgMS4xIDIuNCAyLjR2MTEuOGMwIDEuNC0xLjEgMi40LTIuNCAyLjQiLz48L3N2Zz4="

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _design = __webpack_require__(516);
	
	var _design2 = _interopRequireDefault(_design);
	
	var _frontend = __webpack_require__(517);
	
	var _frontend2 = _interopRequireDefault(_frontend);
	
	var _backend = __webpack_require__(515);
	
	var _backend2 = _interopRequireDefault(_backend);
	
	var _mobile = __webpack_require__(518);
	
	var _mobile2 = _interopRequireDefault(_mobile);
	
	__webpack_require__(403);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Directions = function Directions() {
	  return _react2.default.createElement(
	    'section',
	    { className: 'directions__wrapper' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns' },
	        _react2.default.createElement(
	          'div',
	          { className: 'directions' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'h1' },
	            '\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'card__list' },
	            _react2.default.createElement(
	              'li',
	              { className: 'card__item' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card__img' },
	                _react2.default.createElement('img', { src: _design2.default, alt: 'design' })
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'item__caption' },
	                '\u0414\u0438\u0437\u0430\u0439\u043D'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'item__text' },
	                'UX / UI'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'card__item' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card__img' },
	                _react2.default.createElement('img', { src: _frontend2.default, alt: 'frontend' })
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'item__caption' },
	                'Frontend'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'item__text' },
	                'React / HTML5 / CSS3 / ES6 / Sass / Angular / CoffeeScript / Backbone'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'card__item' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card__img' },
	                _react2.default.createElement('img', { src: _backend2.default, alt: 'backend' })
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'item__caption' },
	                'Backend'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'item__text' },
	                'Ruby / Elixir / Node.js / GO / Erlang / C / C++ / MySql / Postgres / MemCache / Redis / NATS'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'card__item' },
	              _react2.default.createElement(
	                'div',
	                { className: 'card__img' },
	                _react2.default.createElement('img', { src: _mobile2.default, alt: 'mobile' })
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'item__caption' },
	                '\u041C\u043E\u0431\u0438\u043B\u044C\u043D\u0430\u044F \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'item__text' },
	                'iOS / Android / React Native / Windows / Ionic'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Directions;
	module.exports = exports['default'];

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (OriginalComponent) {
	  return function (_Component) {
	    _inherits(Wrapper, _Component);
	
	    function Wrapper() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Wrapper);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	        isOpen: false
	      }, _this.toggleOpen = function (ev) {
	        _this.setState({
	          isOpen: !_this.state.isOpen
	        });
	        ev && ev.preventDefault && ev.preventDefault();
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Wrapper.prototype.render = function render() {
	      return _react2.default.createElement(OriginalComponent, _extends({}, this.props, this.state, { toggleOpen: this.toggleOpen }));
	    };
	
	    return Wrapper;
	  }(_react.Component);
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(25);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Directions = __webpack_require__(208);
	
	var _Directions2 = _interopRequireDefault(_Directions);
	
	var _Cert = __webpack_require__(206);
	
	var _Cert2 = _interopRequireDefault(_Cert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	  return _react2.default.createElement(
	    'main',
	    { className: 'myMain' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'About' }),
	    _react2.default.createElement(_Directions2.default, null),
	    _react2.default.createElement(
	      'section',
	      { className: 'about__wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'about' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'h2' },
	              '\u041E\u0441\u043D\u043E\u0432\u043D\u044B\u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u044B:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'ul' },
	              _react2.default.createElement(
	                'li',
	                { className: 'li' },
	                '- \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 web-\u043F\u043E\u0440\u043E\u0435\u043A\u0442\u043E\u0432: \u043A\u0430\u043A \u0446\u0435\u043B\u0438\u043A\u043E\u043C, \u0442\u0430\u043A \u0438 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u043C\u0438 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0430\u043C\u0438'
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'li' },
	                '- \u043A\u043E\u043D\u0441\u0430\u043B\u0442\u0438\u043D\u0433\u043E\u0432\u044B\u0435 \u0443\u0441\u043B\u0443\u0433\u0438: \u043F\u043E\u043C\u043E\u0433\u0430\u0435\u043C \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0435 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u044B \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0438'
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'li' },
	                '- project resque: \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0435 \u0443\u0441\u0438\u043B\u0435\u043D\u0438\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0437\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0430 \u0441 \u0446\u0435\u043B\u044C\u044E \u0432\u044B\u0442\u044F\u043D\u0443\u0442\u044C "\u043F\u043E\u043A\u043E\u0441\u0438\u0432\u0448\u0438\u0439\u0441\u044F" \u043F\u0440\u043E\u0435\u043A\u0442'
	              )
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'h2' },
	              '\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 consulting:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'ul' },
	              _react2.default.createElement(
	                'li',
	                { className: 'li' },
	                '- agile coaching, scrum, kanban, \u043A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u043A\u0443\u043B\u044C\u0442\u0443\u0440\u0430'
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'li' },
	                '- \u043F\u043E\u043C\u043E\u0449\u044C \u0438 \u044D\u043A\u0441\u043F\u0435\u0440\u0442\u043D\u044B\u0435 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438 \u043F\u043E \u0432\u044B\u0431\u043E\u0440\u0443 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0439 \u0438 \u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u043E\u0432'
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'li' },
	                '- UX-\u043F\u0440\u043E\u0435\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435(\u0441\u0431\u043E\u0440/\u0430\u043D\u0430\u043B\u0438\u0437 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u0439 \u0431\u0438\u0437\u043D\u0435\u0441\u0430 \u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439, \u0441\u0446\u0435\u043D\u0430\u0440\u0438\u0438, \u043F\u0440\u043E\u0442\u043E\u0442\u0438\u043F\u0438\u043E\u0432\u0430\u043D\u0438\u0435, \u044E\u0437\u0430\u0431\u0438\u043B\u0438\u0442\u0438 \u0442\u0435\u0441\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435)'
	              )
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'h2' },
	              '\u041D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 "project resque":'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'p' },
	              '\u041D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u043D\u044B\u0439 \u043E\u043F\u044B\u0442 \u0447\u043B\u0435\u043D\u043E\u0432 \u043A\u043E\u043C\u0430\u043D\u0434\u044B Headmade \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u0431\u044B\u0441\u0442\u0440\u043E \u0432\u043B\u0438\u0442\u044C\u0441\u044F \u0432 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439 \u043A\u043E\u043B\u043B\u0435\u043A\u0442\u0438\u0432 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0437\u0430\u043A\u0430\u0437\u0447\u0438\u043A\u0430 \u0438 \u043D\u0430\u0447\u0430\u0442\u044C \u0430\u043A\u0442\u0438\u0432\u043D\u043E \u0441\u043F\u043E\u0441\u043E\u0431\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C \u0443\u0441\u043A\u043E\u0440\u0435\u043D\u0438\u044E \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0438.'
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'h2' },
	              '\u0423 \u043D\u0430\u0441 \u0435\u0441\u0442\u044C \u0443\u0441\u043F\u0435\u0448\u043D\u044B\u0439 \u043E\u043F\u044B\u0442 "\u0432\u044B\u0442\u044F\u0433\u0438\u0432\u0430\u043D\u0438\u044F":'
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'ul' },
	              _react2.default.createElement(
	                'li',
	                { className: 'li' },
	                '- \u0437\u0430\u0442\u044F\u043D\u0443\u0432\u0448\u0438\u0445\u0441\u044F \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432'
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'li' },
	                '- \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432, \u0437\u0430\u0448\u0435\u0434\u0448\u0438\u0445 \u0432 \u0430\u0440\u0445\u0438\u0442\u0435\u043A\u0442\u0443\u0440\u043D\u044B\u0439 \u0442\u0443\u043F\u0438\u043A'
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'li' },
	                '- \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0449\u0438\u0445 \u043D\u0435\u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u043F\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u043E\u0439 \u0437\u0430\u0434\u0430\u0447\u0435 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u0438 \u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u044B'
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'li' },
	                '- \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432, \u0438\u0437 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0432\u043D\u0435\u0437\u0430\u043F\u043D\u043E \u0443\u0445\u043E\u0434\u044F\u0442 \u0432\u0435\u0434\u0443\u0449\u0438\u0435 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0438'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-09b39760418e7b0ac2cd.js